<template>
  <!-- Create / Edit -->
  <v-dialog v-model="dialog" width="1360" persistent fullscreen>
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
        <v-row no-gutters>
          <v-col cols="12" md="4">
            <!-- ========================================= -->
            <!--               Subordination               -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4">{{
              $t("subordination")
            }}</v-subheader>
            <div class="pa-4 px-6">
              <v-autocomplete
                v-model="form.subordination.select"
                :items="form.subordination.items"
                :rules="selectRules"
                item-text="name_local"
                item-value="id_local"
                :label="$t('localManagerLabel')"
                outlined
                dense
                return-object
                required
              ></v-autocomplete>
            </div>

            <!-- ========================================= -->
            <!--             Registration form             -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4">{{
              $t("registrationForm")
            }}</v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                :label="$t('fullNameLabel')"
                v-model="form.fullName"
                :rules="fullNameRules"
                required
                clearable
                outlined
                dense
                autofocus
              ></v-text-field>
              <v-text-field
                :label="$t('cpfLabel')"
                v-model="form.doc"
                :rules="requiredRules"
                required
                clearable
                outlined
                dense
                v-mask="maskDoc"
              ></v-text-field>
              <v-text-field
                :label="$t('emailLabel')"
                v-model="form.email"
                :rules="emailRules"
                clearable
                outlined
                dense
                autocapitalize="off"
                name="newEmailUser"
              ></v-text-field>
              <v-row>
                <div class="col-12 col-md-6 py-0">
                  <v-text-field
                    :label="$t('cellphoneOneLabel')"
                    v-model="form.phone1"
                    required
                    clearable
                    outlined
                    dense
                    :rules="requiredRules"
                    v-mask="maskPhone"
                  ></v-text-field>
                </div>
                <div class="col-12 col-md-6 py-0">
                  <v-text-field
                    :label="$t('cellphoneTwoLabel')"
                    v-model="form.phone2"
                    clearable
                    outlined
                    dense
                    v-mask="maskPhone"
                  ></v-text-field>
                </div>
              </v-row>
              <v-row>
                <div class="col-12 col-md-4 py-0">
                  <v-text-field
                    :label="$t('cepLabel')"
                    v-model="form.zipCode"
                    :loading="loadingZipCode"
                    :disabled="disabled"
                    required
                    outlined
                    dense
                    v-mask="'##.###-###'"
                    append-icon="mdi-magnify"
                    @click:append="consultZipCode(form.zipCode)"
                    @blur="consultZipCode(form.zipCode)"
                  ></v-text-field>
                </div>
                <div class="col-12 col-md-8 py-0">
                  <v-text-field
                    :label="$t('addressLabel')"
                    v-model="form.address"
                    :disabled="disabled"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-row>
              <v-row>
                <div class="col-12 col-md-6 py-0">
                  <v-select
                    v-model="form.state.select"
                    :items="form.state.items"
                    item-text="nome"
                    item-value="id"
                    :label="$t('stateLabel')"
                    :disabled="disabled"
                    outlined
                    dense
                    return-object
                    persistent-hint
                    :loading="loadingState"
                    @change="getCitys(form.state.select.id)"
                    required
                    class="mb-2"
                    :hint="$t('toSaveStateMsg')"
                  ></v-select>
                </div>
                <div class="col-12 col-md-6 py-0">
                  <v-select
                    v-model="form.city.select"
                    :items="form.city.items"
                    item-text="nome"
                    item-value="id"
                    :label="$t('cityLabel')"
                    :disabled="disabled"
                    outlined
                    dense
                    return-object
                    required
                  ></v-select>
                </div>
              </v-row>
              <v-textarea
                v-model="form.informacoes"
                :label="$t('commentsLabel')"
                outlined
                height="106"
              ></v-textarea>
            </div>
          </v-col>

          <v-col
            cols="12"
            md="4"
            v-if="permissions.limit_agent == 1 || permissions.credit_agent == 1"
          >
            <!-- ========================================= -->
            <!--                  Limits                   -->
            <!-- ========================================= -->
            <div class="pa-4 px-6">
              <v-progress-circular
                v-if="limitsProgress"
                indeterminate
              ></v-progress-circular>
              <template v-if="permissions.limit_agent == 1">
                <v-subheader class="overline pt-4">{{
                  $t("limitsLabel")
                }}</v-subheader>
                <v-text-field
                  v-model="form.partida"
                  :label="$t('valuePerMatchSingleBet')"
                  :prefix="this.$t('labelCurrency')"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.limitDayBet"
                  :label="$t('dailyBetLimit')"
                  :prefix="this.$t('labelCurrency')"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.limitDayBetSingle"
                  :label="$t('dailyLimitSingleBets')"
                  :prefix="this.$t('labelCurrency')"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.limitDayBetDouble"
                  :label="$t('dailyLimitDoubleBets')"
                  :prefix="this.$t('labelCurrency')"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.teto"
                  :label="$t('maximumAgentAward')"
                  :prefix="this.$t('labelCurrency')"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-if="this.$operator.retail == 2"
                  v-model="form.vendas"
                  :label="$t('creditSaleLimit')"
                  :prefix="this.$t('labelCurrency')"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.fator_confiabilidade"
                  min="0"
                  max="1"
                  step="0.01"
                  :label="$t('realiabilityFactor')"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
              </template>
            </div>
            <template v-if="permissions.credit_agent == 1">
              <v-subheader class="overline pt-4">{{
                retail == 1 ? $t("agentBalance") : $t("generalSalesLimit")
              }}</v-subheader>
              <div class="pa-4 px-6">
                <v-text-field
                  v-model="form.limit_retention"
                  :label="
                    retail == 1 ? $t('agentBalance') : $t('generalSalesLimit')
                  "
                  :prefix="$t('labelCurrency')"
                  outlined
                  dense
                  :rules="retail == 1 ? [] : requiredRules"
                  type="number"
                  :disabled="showAgentBalanceIncrement && retail == 1"
                ></v-text-field>
                <!-- Aumenta ou reseta o saldo (retail 1) -->
                <div v-if="retail == 1 && showAgentBalanceIncrement">
                  <v-btn
                    @click="showEditBalance = !showEditBalance"
                    class="mb-3"
                  >
                    {{ $t("editAgentBalance") }}
                  </v-btn>
                  <div v-if="showEditBalance">
                    <v-text-field
                      v-model="form.limit_retention_increment"
                      :label="$t('incrementAgentBalance')"
                      :prefix="$t('labelCurrency')"
                      outlined
                      dense
                      type="number"
                    ></v-text-field>
                    <div v-if="retail == 1" class="d-flex justify-space-around">
                      <v-btn
                        class="mb-3"
                        :loading="loadingLimitRetentionAdd"
                        v-on:click.prevent="addLimitRetention"
                        >{{ $t("add") }}
                      </v-btn>
                      <v-btn
                        class="mb-3"
                        :loading="loadingLimitRetentionReset"
                        v-on:click.prevent="resetLimitRetention"
                        >{{ $t("reset") }}
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <!-- ========================================= -->
            <!--                CredentialS                -->
            <!-- ========================================= -->
            <!-- ========================================= -->
            <!--              Configurations               -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4">{{
              $t("settingsLabel")
            }}</v-subheader>
            <div class="pa-4 px-6">
              <v-select
                v-model="form.activeLive.select"
                :items="form.activeLive.items"
                item-text="name"
                item-value="id"
                :label="$t('activateLiveLabel')"
                outlined
                dense
                return-object
                :rules="selectRules"
                required
              ></v-select>
              <v-select
                v-model="form.awards.select"
                :items="form.awards.items"
                item-text="name"
                item-value="id"
                :label="$t('viewAwardees')"
                outlined
                dense
                return-object
                :rules="selectRules"
                required
              ></v-select>
              <v-select
                v-model="form.status.select"
                :items="form.status.items"
                item-text="name"
                item-value="id"
                :label="$t('statusLabel')"
                outlined
                dense
                return-object
                :rules="selectRules"
                required
              ></v-select>
            </div>
            <v-subheader class="overline pt-4">{{
              $t("accessCredential")
            }}</v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                :label="$t('labelLogin')"
                v-model="form.login"
                :rules="usernameRules"
                required
                clearable
                outlined
                dense
                autocapitalize="off"
              ></v-text-field>
              <template v-if="edit">
                <v-btn @click="editPassword = !editPassword" class="mb-3">
                  {{ $t("btnChangePassword") }}
                </v-btn>
              </template>
              <template v-if="editPassword || !edit">
                <v-text-field
                  :class="[
                    !form.password || show ? 'show-password' : 'hide-password',
                  ]"
                  :label="$t('passwordLabel')"
                  v-model="form.password"
                  :rules="passwordRules"
                  required
                  clearable
                  outlined
                  dense
                  name="newPasswordUser"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
                  type="text"
                  :counter="8"
                  maxlength="8"
                  autocapitalize="off"
                ></v-text-field>
                <v-text-field
                  :class="[
                    !form.confirmPassword || show1
                      ? 'show-password'
                      : 'hide-password',
                  ]"
                  :label="$t('confirmNewPassword')"
                  v-model="form.confirmPassword"
                  :rules="confirmPasswordRules"
                  required
                  clearable
                  outlined
                  dense
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show1 = !show1"
                  type="text"
                  :counter="8"
                  maxlength="8"
                  autocapitalize="off"
                ></v-text-field>
              </template>
            </div>
          </v-col>
        </v-row>

        <!-- ========================================= -->
        <!--                 Actions                   -->
        <!-- ========================================= -->
        <v-divider></v-divider>

        <v-alert
          class="ma-4"
          type="warning"
          v-for="item in handleError.items"
          :key="item"
        >
          {{ item }}
        </v-alert>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="info"
            :loading="loading"
            v-on:click.prevent="updateAgent"
            type="submit"
            :disabled="!valid"
            >{{ $t("btnSave") }}</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
export default {
  name: "local-manager-user-update",
  data: () => ({
    // operator: "",
    showEditBalance: false,
    loadingLimitRetentionAdd: false,
    loadingLimitRetentionReset: false,
    retail: null,
    showAgentBalanceIncrement: false,
    edit: false,
    valid: false,
    loading: false,
    disabled: false,
    loadingZipCode: false,
    loadingState: false,
    show: false,
    show1: false,
    limitsProgress: true,
    editPassword: false,
    maskDoc: "###.###.###-##",
    maskPhone: "(##) #####-####",
    handleError: {
      items: [],
    },
    //Type Text to No Complete Passwords
    fieldTypes: {
      password: "text",
    },
    //
    // Validate Forms:
    fullNameRules: [validate.required, validate.max],
    docRules: [validate.required, validate.docMax],
    emailRules: [validate.validEmail],
    // phone1Rules: [validate.phoneCounterEdit],
    phone2Rules: [validate.phoneCounter2],
    selectRules: [validate.selectRequired],
    requiredRules: [validate.required, validate.max],
    usernameRules: [
      validate.required,
      validate.usernameMax,
      validate.username,
      validate.max,
    ],
    passwordRules: [
      validate.required,
      validate.passRule,
      validate.passCaracter,
      validate.max,
    ],
    // Permissions:
    permissions: {
      limit_agent: 0,
      reward_bet: 0,
    },
    // Edit
    id_agent: "",

    form: {
      // Sector: Subordination
      subordination: {
        select: [],
        items: [],
      },
      // Sector: Registration form
      fullName: "",
      doc: "",
      phone1: "",
      phone2: "",
      email: "",
      zipCode: "",
      address: "",
      state: {
        select: [],
        items: [],
      },
      city: {
        select: [],
        items: [],
      },
      //  Sector: Limits
      limitDayBet: undefined,
      limitDayBetSingle: undefined,
      limitDayBetDouble: undefined,
      partida: undefined,
      teto: undefined,
      vendas: undefined,
      limit_retention: undefined,
      fator_confiabilidade: undefined,
      informacoes: "",
      //  Sector: Configurations
      activeLive: {
        select: { id: 1, name: "Sim" },
        items: [
          { id: 1, name: "Sim" },
          { id: 0, name: "Não" },
        ],
      },
      status: {
        select: { id: 1, name: "Ativo" },
        items: [
          { id: 1, name: "Ativo" },
          { id: 0, name: "Bloqueado" },
        ],
      },
      awards: {
        select: { id: 0, name: "Não" },
        items: [
          { id: 1, name: "Sim" },
          { id: 0, name: "Não" },
        ],
      },
      // Sector: CredentialS
      login: "",
      password: "",
      confirmPassword: "",
    },
  }),
  mounted() {
    this.retail = localStorage.getItem("operator-retail");
    const isEditAgentRoute =
      this.$route.name == "RegionalManagerUsersAgentsEdit";

    if (isEditAgentRoute) {
      this.showAgentBalanceIncrement = true;
    }
  },
  async created() {
    // Translate Items Form
    this.form.activeLive = this.formTranslate.activeLive;
    this.form.status = this.formTranslate.status;
    this.form.awards = this.formTranslate.awards;
    // Retrieve Local Managers
    // Retrieve States
    // Retrieve Permissions
    let localManagersResponse = this.$request.post(
      "regionalManager/locals/list",
      { status: 1 }
    );
    let statesResponse = this.$axios.get("player/register/fetchStates");
    let permissionsResponse = this.$axios.get(
      "regionalManager/profile/permissions"
    );
    // Request's Simultaneously
    let localManagers = await localManagersResponse;
    let states = await statesResponse;
    let permissions = await permissionsResponse;
    this.limitsProgress = false;
    // Set Responses:
    this.form.subordination.items = localManagers.dados;
    this.form.state.items = states.data.dados;
    this.permissions = permissions.data.dados;
    // Retrieves Defaults:
    this.form.teto = this.$operator.max_prize;
    // =================================================== //
    // IF - Edit
    // =================================================== //
    if (!this.$route.params.id) {
      return;
    }
    this.edit = true;
    let id_user = this.$route.params.id;
    let data = await this.$request.post("/regionalManager/agents/getAgent", {
      id_user,
    });
    const {
      address,
      document,
      email,
      id,
      id_local,
      login,
      nome,
      phone,
      live,
      status,
      telephone,
      limit_retention,
      total_daily,
      total_daily_double,
      total_daily_simple,
      partida,
      teto,
      vendas,
      info,
      zip_code,
      premiadas,
      fator_confiabilidade,
    } = data.dados;
    // Registration form
    this.form.fullName = nome;
    this.form.doc = document;
    this.form.email = email;
    this.form.phone1 = phone;
    this.form.phone2 = telephone;
    this.form.zipCode = zip_code;
    this.form.address = address;
    this.consultZipCode(zip_code);
    this.form.informacoes = info;
    //  Sector: Configurations
    this.form.activeLive.select = {
      id: Number(live),
      name: live == "0" ? "Não" : "Sim",
    };
    this.form.awards.select = {
      id: Number(premiadas),
      name: premiadas == "0" ? "Não" : "Sim",
    };
    this.form.status.select = {
      id: Number(status),
      name: status == "0" ? "Bloqueado" : "Ativo",
    };
    // Limits
    this.form.limitDayBet = total_daily;
    this.form.limitDayBetSingle = total_daily_simple;
    this.form.limitDayBetDouble = total_daily_double;
    this.form.limit_retention = limit_retention;
    this.form.partida = partida;
    this.form.teto = teto;
    this.form.vendas = vendas;
    this.form.fator_confiabilidade = fator_confiabilidade;
    // Login
    this.form.login = login;
    // Edit
    this.id_agent = id;
    // Handle Local Manager - Subordination:
    var select = this.form.subordination.items.filter((item) => {
      return item.id_local == id_local;
    });
    this.form.subordination.select = select[0];
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    retail() {
      return this.$store.state.operator.retail;
    },
    formTranslate() {
      return {
        //  Sector: Configurations
        activeLive: {
          select: { id: 1, name: this.$t("yes") },
          items: [
            { id: 1, name: this.$t("yes") },
            { id: 0, name: this.$t("no") },
          ],
        },
        status: {
          select: { id: 1, name: this.$t("active") },
          items: [
            { id: 1, name: this.$t("active") },
            { id: 0, name: this.$t("blocked") },
          ],
        },
        awards: {
          select: { id: 0, name: this.$t("no") },
          items: [
            { id: 1, name: this.$t("yes") },
            { id: 0, name: this.$t("no") },
          ],
        },
      };
    },
    // Confirm Password Rules:
    confirmPasswordRules() {
      const rules = [];
      const req = "required";
      if (req) {
        const rule = (v) => !!v || this.$t("rulesPassMatch");
        rules.push(rule);
      }
      if (this.form.confirmPassword) {
        const rule = (v) =>
          (!!v && v) === this.form.password || this.$t("rulesRepeatPassword");
        rules.push(rule);
      }
      return rules;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    async addLimitRetention() {
      this.loadingLimitRetentionAdd = true;

      const value = this.form.limit_retention_increment;

      const body = { id_user: this.$route.params.id, value };

      try {
        const response = await this.$request.post(
          "/regionalManager/retail/agents/addAgentCredit",
          body
        );
        this.form.limit_retention = response.dados.credito_atual;
        this.$store.commit("setFeedbackSnack", {
          msg: response.messages,
          color: "success",
        });
      } catch (e) {
        console.error(e);
      }

      this.loadingLimitRetentionAdd = false;
    },
    async resetLimitRetention() {
      this.loadingLimitRetentionReset = true;

      try {
        const response = await this.$request.post(
          "/regionalManager/retail/agents/resetAgentCredit",
          { id_user: this.$route.params.id }
        );
        this.form.limit_retention = 0;
        this.$store.commit("setFeedbackSnack", {
          msg: response.messages,
          color: "success",
        });
      } catch (e) {
        console.error(e);
      }

      this.loadingLimitRetentionReset = false;
    },
    //
    //
    // Consult CEP (ZipCode)
    async consultZipCode(zipCode) {
      if (!zipCode) return;
      const body = {
        cep: zipCode.replace(/[^0-9]+/g, ""),
      };
      // handle fields
      this.disabled = true;
      this.loadingZipCode = true;
      try {
        // 1. Resques CEP/ZipCode
        const response = await this.$request.post(
          "player/register/fetchCep",
          body
        );
        // 2. Handle Address:
        this.form.address = response.dados.logradouro;
        // 3. Handle Select-State:
        const uf = response.dados.uf;
        const state = this.form.state.items.filter((item) => item.uf == uf);
        this.form.state.select = state[0];
        this.getCitys(state[0].id, response.dados.cidade);
      } catch (error) {
        console.log(error);
      } finally {
        // handle fields end.
        this.loadingZipCode = false;
        this.disabled = false;
      }
    },
    //
    //
    // getCitys
    async getCitys(stateId, nameCity) {
      this.loadingState = true;
      this.disabled = true;
      try {
        const citys = await this.$request.post("player/register/fetchCities", {
          id_state: stateId,
        });
        this.form.city.items = citys.dados;
        if (!nameCity) {
          return;
        }
        const city = this.form.city.items.filter(
          (item) => item.nome == nameCity.toUpperCase()
        );
        this.form.city.select = city[0];
        if (this.form.address == "LOGRADOURO" && nameCity == "CIDADE") {
          this.form.city.items.push({
            id: "00000",
            nome: "CIDADE NÃO ENCONTRADA",
          });
          const city = this.form.city.items.filter(
            (item) => item.nome == "CIDADE NÃO ENCONTRADA"
          );
          this.form.city.select = city[0];
          this.form.address = "RUA NÃO ENCONTRADA";
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.disabled = false;
        this.loadingState = false;
      }
    },
    //
    //
    // updateAgent: Create or Edit Agent.
    async updateAgent() {
      if (!this.$refs.form.validate() && !this.edit) {
        return;
      }
      if (this.form.phone1 != null && this.form.doc != null) {
        if (this.form.phone1.length != 15) {
          this.$store.commit("setFeedbackSnack", {
            msg: "Telefone deve conter 11 digitos",
            color: "red",
          });
          return;
        }
        if (this.form.doc.length != 14) {
          this.$store.commit("setFeedbackSnack", {
            msg: "CPF deve conter 11 digitos",
            color: "red",
          });
          return;
        }
      }
      // Global progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;
      // Body Request Verify Login
      const verifyLogin = {
        domain: this.$localStorage.getItem("user_data").db_name,
        login: this.form.login,
      };
      // Body Request Create Agent
      const formUpdateAgent = {
        nome: this.form.fullName,
        login: this.form.login,
        password: this.form.password,
        status: this.form.status.select.id,
        id_gerente: this.form.subordination.select.id_local,
        email: this.form.email,
        cpf: this.form.doc.replace(/[^0-9]+/g, ""),
        endereco: this.form.address,
        municipio: this.form.city.select.id,
        estado: this.form.state.select.id,
        telefone: this.form.phone2
          ? this.form.phone2.replace(/[^0-9]+/g, "")
          : "",
        celular: this.form.phone1.replace(/[^0-9]+/g, ""),
        cep: this.form.zipCode.replace(/[^0-9]+/g, ""),
        limite_diario: this.form.limitDayBet,
        limite_simples: this.form.limitDayBetSingle,
        limite_duplas: this.form.limitDayBetDouble,
        partida: this.form.partida,
        teto: this.form.teto,
        vendas: this.form.vendas,
        limit_retention: this.form.limit_retention,
        informacoes: this.form.informacoes,
        live: this.form.activeLive.select.id,
        premiadas: this.form.awards.select.id,
        fator_confiabilidade: this.form.fator_confiabilidade,
      };
      // Submit Form
      try {
        if (this.edit) {
          Object.assign(formUpdateAgent, { id_agent: this.id_agent });
        } else {
          // Add Agent - Verify existing login
          const verify = await this.$request.post(
            "main/fetchLogin",
            verifyLogin
          );
          if (verify.length == 0) {
            return;
          }
        }
        const updateEndpoint = this.edit
          ? "regionalManager/agents/editAgent"
          : "regionalManager/agents/addAgent";
        const result = await this.$request.post(
          updateEndpoint,
          formUpdateAgent
        );
        if (result.length == 0) {
          return;
        }
        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });
        if (!this.edit) {
          this.$refs.form.reset();
        }
        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } catch (error) {
        // Multiple error handler:
        if (error.response.status == 406) {
          const items = [];
          var obj = error.response.data.messages;
          for (var [key, value] of Object.entries(obj)) {
            const item = `${key}: ${value}`;
            items.push(item);
          }
          this.handleError.items = items;
        }
      } finally {
        this.loading = false;
      }
    },
    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
    // handleType() {
    //   this.fieldTypes.password = "password";
    // },
  },
};
</script>
